import './assets/js/polyfill'
// --------------------

import React from 'react'
import ReactDOM from 'react-dom'
import Router from './routers'

import store from 'redux/store'

import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import 'leaflet/dist/leaflet.css'

/**
 * Fix Leaflet’s Marker Icon Issue
 */
import L from 'leaflet'
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'

delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x, // <- this was missing
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
})

// end of Leaflet’s Marker Icon Issue fix

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)
